import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  CaptionText,
} from "../../components/typography";
import { useEffect } from "react";
import AppLayout from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { COLORS } from "../../assets/utils/enums/colors";
import { motion } from "framer-motion";

export default function MainFinancePage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/finance") {
      navigate("/finance/income/main", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <AppLayout className="" blockType="projects" loaderState={false}>
      <Headline
        headline={HeadlineTypeEnum.FINANCE}
        theme={ThemeTypeEnum.LIGHT}
      />
      <TabList>
        <StyledTab
          to="/finance/income/main"
          className={({ isActive }) => (isActive ? "active" : "")}
          $color={COLORS.secondary1} 
        >
          Надходження
          {location.pathname === "/finance/income/main" && (
            <Underline $color={COLORS.secondary1} layoutId="underline" />
          )}
        </StyledTab>

        <StyledTab
          to="/finance/expense/main"
          className={({ isActive }) => (isActive ? "active" : "")}
          $color={COLORS.secondary1} 
        >
          Витрати
          {location.pathname === "/finance/expense/main" && (
            <Underline $color={COLORS.secondary1} layoutId="underline" />
          )}
        </StyledTab>
      </TabList>

      <Outlet />
    </AppLayout>
  );
}

export const TabList = styled.div`
  display: flex;
  border-bottom: 2px solid ${COLORS["light-bg-color"]};
  flex-grow: 1;
`;

export const StyledTab = styled(NavLink)<{$color: string}>`
  position: relative;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 500;
  color: ${COLORS["bg-text-color"]};
  border-radius: 8px;
  background: transparent;
  text-decoration: none;
  text-align: center;
  ${CaptionText.componentStyle.rules.join("")}
  flex: 1;
  transition: color 0.3s ease;

  &.active {
    color: ${({$color})=> $color};
  }

  &:hover {
    color: ${COLORS.blue};
  }
`;

export const Underline = styled(motion.div)<{$color: string}>`
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: ${({$color})=> $color};
  border-radius: 20px;
`;
